export interface ChangeExamEventRequest {
  testEventId: number;
}
